import { defineComponent, computed } from "vue";
import { u as useRouterLinkProps, a as useRouterLink } from "../../../composables/useRouterLink-48153ec5.mjs";
const _sfc_main = defineComponent({
  name: "VaBreadcrumbsItem",
  props: {
    ...useRouterLinkProps,
    disabled: { type: Boolean, default: false },
    label: { type: String, default: "" }
  },
  setup: (props) => {
    const { tagComputed, hrefComputed, isLinkTag } = useRouterLink(props);
    const classComputed = computed(() => ({
      "va-breadcrumb-item--link": isLinkTag.value
    }));
    return { tagComputed, hrefComputed, classComputed };
  }
});
export {
  _sfc_main as _
};

import '../../../../VaBreadcrumbsItem.css';
//# sourceMappingURL=VaBreadcrumbsItem.vue_vue_type_script_lang-2aec962e.mjs.map
